import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {Icon} from '@stubhub/bamboo';

import '../styles/store-card.scss';

const StoreCard = ({store, active, onClick}) => {
  if (!store || !Object.keys(store).length) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick(store);
    }
  };

  const countryCode = store.code;
  const classes = cx(
    'store-card',
    {'store-card--active': active},
    countryCode && countryCode.length ? `flag-${countryCode}` : ''
  );

  return (
    <li data-testid="store-card" className={classes} onClick={handleClick}>
      <a className="store-card__content">
        <span data-testid="store-card-country" className="store-card__country">
          {store.name}
          {active && <Icon name="Check" description="Active store" className="store-card--active__icon" />}
        </span>
        <span className="store-card__domain" data-testid="store-card-domain">
          {store.domain}
        </span>
      </a>
    </li>
  );
};

StoreCard.propTypes = {
  /**  Details of the store, containing 'id', 'code', 'domain', and 'name' (optional), 'url' (optional) */
  store: PropTypes.shape({
    /**  Unique identifier for the store  */
    id: PropTypes.string.isRequired,

    /**  Code representing the store  */
    code: PropTypes.string.isRequired,

    /**  Domain of the store  */
    domain: PropTypes.string.isRequired,

    /**  Name of the store */
    name: PropTypes.string,

    /**  URL of the store */
    url: PropTypes.string,
  }).isRequired,

  /**  Indicates whether the store card is active or not */
  active: PropTypes.bool,

  /**  Function triggered on clicking the store card  */
  onClick: PropTypes.func,
};

export default StoreCard;
